/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Reference_Record_InvalidInputs */

const en_error_reference_record_invalid = /** @type {(inputs: Error_Reference_Record_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The record cannot be saved as it is: correct the fields marked.`)
};

/**
* | output |
* | --- |
* | "The record cannot be saved as it is: correct the fields marked." |
*
* @param {Error_Reference_Record_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_reference_record_invalid = /** @type {((inputs?: Error_Reference_Record_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Reference_Record_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_reference_record_invalid(inputs)
});